import { memo } from "react";
import * as Pi from "react-icons/pi";
import Loader from "react-spinners/ClipLoader";
import logger from "../../Utils/logger";

// ---------------------------------------------------
//   ICON MAP (All icons converted to Phosphor)
// ---------------------------------------------------
const ICON_MAP = {
  loader: () => <Loader color="var(--primary)" size={14} />,

  dashboard: Pi.PiSquaresFour,

  copy: Pi.PiCopy,
  search: Pi.PiMagnifyingGlass,
  plus: Pi.PiPlus,
  dash: Pi.PiMinus,
  cross: Pi.PiX,
  delete: Pi.PiXCircle,
  edit: Pi.PiPencilSimpleLine,
  trash: Pi.PiTrash,

  back: Pi.PiArrowLeft,
  backangle: Pi.PiCaretLeft,
  rightArrow: Pi.PiArrowRight,
  rightSideArrow: Pi.PiCaretRight,
  leftArrow: Pi.PiCaretLeft,

  leftDoubleAngle: Pi.PiCaretDoubleLeft,
  rightDoubleAngle: Pi.PiCaretDoubleRight,

  angleUp: Pi.PiCaretUp,
  angleDown: Pi.PiCaretDown,
  dropdown: Pi.PiCaretDown,

  menu: Pi.PiList,
  filter: Pi.PiFaders,
  onlyFilter: Pi.PiFaders,
  controlsIcon: Pi.PiSliders,
  sort: Pi.PiArrowsDownUp,
  export: Pi.PiExport,
  dotsVertical: Pi.PiDotsThreeVertical,

  buy: Pi.PiTag,
  rupee: Pi.PiCurrencyInr,
  percent: Pi.PiPercent,
  "credit-notes": Pi.PiCreditCard,

  whatsapp: (props) => <Pi.PiWhatsappLogo color="#25D366" {...props} />,
  blank_whatsapp: Pi.PiWhatsappLogo,

  users: Pi.PiUsers,
  user: Pi.PiUser,
  adduser: Pi.PiUserPlus,
  visit: Pi.PiUserCheck,
  attendance: Pi.PiUsersThree,

  medicine: Pi.PiPill,
  "medicine-category": Pi.PiPill,
  "medicine-bill": Pi.PiPill,
  diagnosis: Pi.PiStethoscope,
  hospital: Pi.PiFirstAid,
  room: Pi.PiHouse,
  bed: Pi.PiBed,
  "next-visit": Pi.PiCalendarCheck,

  inventory: Pi.PiCube,
  inventory_category: Pi.PiCube,

  report: Pi.PiFileText,
  fileImage: Pi.PiImage,
  fileAttachment: Pi.PiPaperclip,
  fileTemplate: Pi.PiFileDashed,
  template: Pi.PiFileDashed,
  folder: Pi.PiFolder,
  application: Pi.PiAppWindow,

  sendIcon: Pi.PiPaperPlaneRight,
  fillArrowBack: Pi.PiArrowBendDownLeft,
  "paper-clip": Pi.PiPaperclip,
  "mic-phone": Pi.PiMicrophone,
  camera: Pi.PiCamera,

  history: Pi.PiClockCounterClockwise,
  comment: Pi.PiChatCircle,
  smile: Pi.PiSmiley,
  laughingEmoji: Pi.PiSmileyNervous,
  staricon: Pi.PiStarHalf,
  alert: Pi.PiWarning,
  info: Pi.PiInfo,
  question: Pi.PiQuestion,
  true: Pi.PiCheck,
  false: Pi.PiX,
  bell: Pi.PiBell,
  "noti-logs": Pi.PiBellRinging,
  digital: Pi.PiCpu,

  truck: Pi.PiTruck,

  exchange: Pi.PiArrowsLeftRight,

  insta: Pi.PiInstagramLogo,
  facebook: Pi.PiFacebookLogo,
  google: Pi.PiGoogleLogo,

  calendar: Pi.PiCalendar,
  clock: Pi.PiClock,

  download: Pi.PiDownload,

  shortcut: Pi.PiLightning,

  listBullet: Pi.PiListBullets,

  Storefront: Pi.PiStorefront,

  outlineDollar: Pi.PiCurrencyDollar,

  messageRounded: Pi.PiChats,

  saleReturn: Pi.PiArrowUUpLeft,

  view: Pi.PiEye,

  "before-after": Pi.PiSplitVertical,

  patients: Pi.PiUsersThree,
  "patient-visit": Pi.PiUserCheck,

  help: Pi.PiQuestion,

  arrowDown: Pi.PiArrowCircleDown,

  lock: Pi.PiLock,
  unlock: Pi.PiLockKey,

  logout: Pi.PiSignOut,

  envelop: Pi.PiEnvelopeSimple,

  building: Pi.PiBuilding,

  "notification-partners": Pi.PiNetwork,
  "noti-logs": Pi.PiBellRinging,

  fileTemplate: Pi.PiFileCode,

  inventory: Pi.PiCube,
  departments: Pi.PiBuildings,
  "service-type": Pi.PiListChecks,
  treatment: Pi.PiSyringe,
  "track-patient": Pi.PiFootprints,
  "data-management": Pi.PiDatabase,
  "digital-pro": Pi.PiMegaphone,
  "medicine-type": Pi.PiTag,
  suppliers: Pi.PiStorefront,

  marketing: Pi.PiMegaphone,

  "notification-management": Pi.PiBell,

  "wa-inbox": Pi.PiChatCenteredDots,

  "expense-category": Pi.PiFolder,
  expense: Pi.PiWallet,
  list: Pi.PiListBullets,
  "medicine-bill": Pi.PiReceipt,
  services: Pi.PiStethoscope,
  doubletick: Pi.PiCheckCircle,
};

// ---------------------------------------------------
//          ICON COMPONENT (clean, final)
// ---------------------------------------------------
const IconResource = memo(({ type, color, size = 20, disabled, ...props }) => {
  const Icon = ICON_MAP[type];

  if (!Icon) {
    logger.error("icon issue:", type);
    return null;
  }

  if (typeof Icon === "function" && !Icon.name.startsWith("Pi"))
    return Icon({ size, color, disabled, ...props });

  return <Icon size={size} color={color} disabled={disabled} {...props} />;
});

export default IconResource;
